import { render, staticRenderFns } from "./o-product-details.vue?vue&type=template&id=1b4a3031&scoped=true&"
import script from "./o-product-details.vue?vue&type=script&lang=js&"
export * from "./o-product-details.vue?vue&type=script&lang=js&"
import style0 from "./o-product-details.vue?vue&type=style&index=0&id=1b4a3031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a3031",
  null
  
)

export default component.exports